module.exports = __webpack_public_path__ + "static/img/head-pic.2ff80e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/head-pic.png
// module id = ekTD
// module chunks = 1